import { forwardRef } from 'react';

import { type TWidgetProps, Widget } from './widget';

type TAttendanceWidgetProps = TWidgetProps & {
  dataTestId?: string;
};

export const AttendanceWidget = forwardRef<
  HTMLDivElement,
  TAttendanceWidgetProps
>(({ dataTestId, ...props }, ref) => {
  return (
    <div ref={ref} data-testid={dataTestId} className="tw-w-full tw-h-full">
      <Widget {...props} />
    </div>
  );
});

AttendanceWidget.displayName = 'AttendanceWidget';
